import { effectiveCourseMeetings } from './courseColorSchedule'

export const CALM_COURSE_PALETTE = [
  ['blue', '파랑', '#C5D9EE'], ['sage', '세이지', '#C3E0D6'],
  ['lavender', '라벤더', '#D6D0EB'], ['sand', '샌드', '#E8D6BA'],
  ['rose', '로즈', '#E8CAD2'], ['olive', '올리브', '#D1DFBA'],
].map(([id, label, bg]) => ({ id: `calm-${id}`, label, bg, text: '#182230', meta: '#475467', border: '#AAB5C2' }))

export function colorLuminance(hex) {
  const values = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255)
    .map(v => v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4)
  return values[0] * .2126 + values[1] * .7152 + values[2] * .0722
}

export function contrastRatio(a, b) {
  const x = colorLuminance(a), y = colorLuminance(b)
  return (Math.max(x, y) + .05) / (Math.min(x, y) + .05)
}

export function readableCardText(fill) {
  return ['#182230', '#ffffff', '#000000'].find(text => contrastRatio(fill, text) >= 4.5)
}

const identity = course => String(course.subjectKey ?? course.stableCourseId ?? course.sourceCourse?.id ?? course.id)
const hash = value => [...value].reduce((sum, char) => (sum * 31 + char.charCodeAt(0)) >>> 0, 0)
function neighbors(a, b) {
  return a.some(x => b.some(y => {
    const overlap = x.startMinute < y.endMinute && y.startMinute < x.endMinute
    const gap = Math.max(x.startMinute, y.startMinute) - Math.min(x.endMinute, y.endMinute)
    return x.weekday === y.weekday && gap <= 30 || Math.abs(x.weekday - y.weekday) === 1 && overlap
  }))
}

// Derived display assignments only. Never writes a course or replaces a saved color.
// Six unique colors first, then balanced reuse with a penalty for neighboring duplicates.
export function assignCalmCourseColors(courses = []) {
  const groups = new Map()
  for (const course of courses) {
    if (course.isOnline) continue
    const key = identity(course)
    if (!groups.has(key)) groups.set(key, { key, courses: [], meetings: [] })
    const group = groups.get(key)
    group.courses.push(course)
    group.meetings.push(...effectiveCourseMeetings(course))
  }
  const usage = Array(6).fill(0), assigned = [], result = new Map()
  for (const group of [...groups.values()].sort((a, b) => a.key.localeCompare(b.key))) {
    const offset = hash(group.key) % 6
    const candidates = CALM_COURSE_PALETTE.map((palette, index) => ({ palette, index,
      score: usage[index] * 10 + assigned.filter(other => other.index === index && neighbors(group.meetings, other.meetings)).length * 100,
      tie: (index - offset + 6) % 6,
    })).sort((a, b) => a.score - b.score || a.tie - b.tie)
    const chosen = candidates[0]
    usage[chosen.index]++
    assigned.push({ ...group, index: chosen.index })
    for (const course of group.courses) result.set(course.id, chosen.palette)
  }
  return result
}
